import { memo } from 'react'

import * as Styled from './styled'
import { IMediaControlItemProps } from './types'
import { Tooltip } from 'components/Tooltip'

const MediaControlItem = ({
  icon,
  onClick,
  tooltipText,
  disabled,
  isActive
}: IMediaControlItemProps) => (
  <Tooltip tooltipText={tooltipText || ''}>
    <Styled.MediaControlItem
      $disabled={!!disabled}
      $isActive={!!isActive}
      onClick={disabled ? () => {} : onClick}
    >
      {icon}
    </Styled.MediaControlItem>
  </Tooltip>
)

export default memo(MediaControlItem)
